import React, {Component} from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import {Popconfirm} from 'antd'


class ModalTableItem extends Component {
    _handleDeleteSetBasket = (barcode) => {
        const {onDeleteSetBasket, basketNumber} = this.props
        onDeleteSetBasket(barcode, basketNumber)
    }

    render() {
        const {item} = this.props
        const {_id, barcode, status, set, order = {}} = item
        const itemAdded = set.filter(setItem => setItem.status === 'added')

        return (
            <tr className={classNames('BasketItem', status)}>
                <td>#{barcode}</td>
                <td>{itemAdded.length}/{set.length}</td>
                <td className='status'>
                    {status === 'completed' ? <span>Đủ SET</span> : status === 'partial' ? <span>Chưa đủ SET</span> : ''}
                </td>
                <td className='statusItem'>
                    {
                        order.status && order.status === 'cancelled' && order.sub_status && order.sub_status === 'cancel-ship' ? '(hủy ship)' : order.production_status &&  order.production_status === 'shipped' ? '(đã ship)' : ''
                    }
                </td>
                <td>
                    {
                        (order.status && order.status === 'cancelled' && order.sub_status && order.sub_status === 'cancel-ship') || (order.production_status && order.production_status === 'shipped') || status === 'completed' ?
                        <Popconfirm
                            title={<span style={{ fontSize: 14 }}>Bạn có chắc chắn muốn xóa giỏ này?</span>}
                            onConfirm={() => this._handleDeleteSetBasket(barcode)}
                            okText="Xóa"
                            cancelText="Hủy"
                            overlayClassName="small-popconfirm"
                        >
                            <span 
                                className='cursor-pointer text-danger' 
                                style={{textDecoration: 'underline'}}
                                // onClick={this._handleDeleteSetBasket}
                            >
                                Xóa giỏ
                            </span>
                        </Popconfirm>
                        : ''
                    }
                </td>
            </tr>
        )
    }
}

ModalTableItem.propTypes = {
    item: PropTypes.object.isRequired,
}

export default ModalTableItem
